export const authFreePaths = new Set(['/', '/admin/login']);
